/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import SectionHeader from './SectionHeader';
import SortableList from '/client/src/components/sortableList/container';
import arrayMove from 'array-move';
import { GET } from '/client/src/api';
import { SingleEvent } from '../../ticketSections/event';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import CssPinner from '/client/src/components/csspinner';
import _ from 'lodash';

type PropsType = {
  onHandleChangeEvent: () => void,
  editablePart?: any,
  eventId: string
};

const Events = (props: PropsType): React.Element => {
  const { onHandleChangeEvent, editablePart } = props;
  const [urls, setUrls] = React.useState([]);
  const urlRef = React.useRef();
  const context = React.useContext(DefaultContainerContext);

  React.useEffect(() => {
    const events = _.get(editablePart, 'ids', []);

    if (_.size(events)) {
      initEvents(events);
    }
  }, []);

  const initEvents = async (events: any) => {
    for (const event of events) {
      await handleAddUrl(event.event_id);
    }
  };

  const onSortEnd = ({ oldIndex, newIndex }: any) => {
    const newItems = arrayMove(urls, oldIndex, newIndex);

    setUrls(newItems);

    onHandleChangeEvent({
      ids: _.map(newItems, (_url: {}, urli: number): {} => {
        return {
          event_id: _url.id,
          placement_index: urli + 1
        };
      })
    });
  };

  const handleAddUrl = async (url: any): boolean => {
    try {
      CssPinner(document.body, true);
      const { result } = await GET(`/api/v1/1/events/${url}`);

      CssPinner(document.body, false);
      let newItems = [];

      if (props.eventId === result.id) {
        CssPinner(document.body, false);

        context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Oops',
          systemDialogContent: 'Cannot add current event!'
        });
        return;
      }

      if (_.findIndex(urls, (i) => i.id === result.id) !== -1) {
        CssPinner(document.body, false);

        context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Oops',
          systemDialogContent: 'Cannot add same event twice!'
        });
        return;
      }

      setUrls((prevUrls) => {
        newItems = [
          ...prevUrls,
          {
            ...result,
            id: result.id,
            name: '',
            temp_id: -1001 - _.size(urls) - 1,
            url,
            event_id: result.id
          }
        ];

        return newItems;
      });

      onHandleChangeEvent({
        ids: _.map(newItems, (_url: {}, urli: number): {} => {
          return {
            event_id: _url.id,
            placement_index: _url.placement_index ? url.placement_index : urli + 1
          };
        })
      });

      urlRef.current.value = '';
    } catch (e) {
      console.log(e);

      CssPinner(document.body, false);

      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops',
        systemDialogContent: 'Sparxo Event URL is invalid!'
      });
    }
  };

  const handleRemoveUrl = (tempId: string | number, id: string | number) => {
    const newItems = _.map(urls, (t: {}): {} => {
      if (t.tempId) {
        if (t.tempId !== tempId) {
          return t;
        }
      } else if (t.id !== id) {
        return t;
      }
    });

    setUrls(_.compact(newItems));

    onHandleChangeEvent({
      ids: _.map(_.compact(newItems), (_url: {}, urli: number): {} => {
        return {
          event_id: _url.id,
          placement_index: urli + 1
        };
      })
    });
  };

  return (
    <>
      <SectionHeader {...props} onHandleChange={onHandleChangeEvent} title={'Other Event List'} />

      <div className="row">
        <div className="col-xs-12">
          <div className="form-group SimpleInput">
            <label className="col-xs-12 control-label">Sparxo Event URL</label>
            <div className="col-xs-12">
              <div className="input-group">
                <span className="input-group-btn" style={{ pointerEvent: 'none' }}>
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={(e: any) => {
                      e.preventDefault();
                    }}
                  >{process.env.EVENT_HOST}</button>
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="input-add-event-url"
                  ref={urlRef}
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => handleAddUrl(urlRef.current.value)}
                  >add event</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!!_.size(urls) &&
        <div className="row">
          <div className="col-xs-12">
            <br />
            <SortableList
              items={urls}
              // eslint-disable-next-line
              onSortEnd={onSortEnd}
              useDragHandle
              useWindowAsScrollContainer
              disableAutoscroll
              // eslint-disable-next-line
              handleRemoveTicket={handleRemoveUrl}
              item={Event2}
              // eslint-disable-next-line
              handleControlTicketData={setUrls}
              withoutTitle
              isClone
            />
          </div>
        </div>
      }
    </>
  );
};

type Event2PropsType = {
  value: {
    temp_id?: string | number,
    url: string
  },
  data: {
    handleControlTicketData: () => void
  }
};

const Event2 = (props: Event2PropsType): React.Element<'div'> => {
  return (
    <SingleEvent
      event={props.value}
      requestUrl={`/api/v1/1/events/${props.value.url}`}
    />
  );
};

export default Events;
